export enum ProjetProperties {
    ID = 'id',
    STATUT = 'statut',
}
